import React, { useState, useEffect } from 'react';
import { IconButton, Popover, Button, Divider, Box } from '@mui/material';
import { FilterList } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import DateInput from '../DateInput/DateInput';

function DateRangeFilter({ value, onChange }) {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [tempRange, setTempRange] = useState({ from: value.from, to: value.to });

    useEffect(() => {
        setTempRange({ from: value.from, to: value.to });
    }, [value]);

    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleApply = () => {
        onChange(tempRange);
        handleClose();
    };

    const handleReset = () => {
        setTempRange({ from: '', to: '' });
        onChange({ from: '', to: '' });
        handleClose();
    };

    return (
        <>
            <IconButton size="small" onClick={handleOpen}>
                <FilterList fontSize="small" />
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{
                    sx: {
                        p: 2,
                        minWidth: 260,
                        overflow: 'visible',
                        zIndex: 1300,
                    },
                }}
            >
                <Box>
                    <DateInput
                        label={t('from_date')}
                        value={tempRange.from}
                        onChange={(val) => setTempRange((prev) => ({ ...prev, from: val }))}
                    />
                    <DateInput
                        label={t('to_date')}
                        value={tempRange.to}
                        onChange={(val) => setTempRange((prev) => ({ ...prev, to: val }))}
                    />
                    <Divider sx={{ my: 1 }} />
                    <Box display="flex" justifyContent="space-between">
                        <Button size="small" onClick={handleReset}>
                            {t('clear')}
                        </Button>
                        <Button size="small" variant="contained" onClick={handleApply}>
                            {t('apply')}
                        </Button>
                    </Box>
                </Box>
            </Popover>
        </>
    );
}

export default DateRangeFilter;
